import http from "@/shared/services/http";
import {PriceListParams} from "@/modules/pricelists/params";

export const createPriceList = (data: any) => http.post(`v1/price-lists`, data);
export const listPriceList = (params: PriceListParams) => http.get(`v1/price-lists`, { params });
export const singlePriceList = (id: number) => http.get(`v1/price-lists/${id}`);
export const updatePriceList = (id: number, data: any) => http.put(`v1/price-lists/${id}`, data);
export const deletePriceList = (id: number) => http.delete(`v1/price-lists/${id}`);
export const listFeeOfPriceList = (priceListId: number, params: any) => http.get(`v1/service-fees/by-price-list/${priceListId}`, { params });
export const editFeeOfPriceList = (id: number, data: any) => http.put(`v1/service-fees/${id}`, data);
export const deleteFeeOfPriceList = (id: number) => http.delete(`v1/service-fees/${id}`);